import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { routesData } from 'src/app/shared/resources/routes.constant';
import { BiometricsInitComponent } from './biometrics-init/biometrics-init.component';
import { BiometricsInstructionsComponent } from './biometrics-instructions/biometrics-instructions.component';
import { BiometricsLauncherComponent } from './biometrics-launcher/biometrics-launcher.component';
import { BiometricsResultComponent } from './biometrics-result/biometrics-result.component';
import { BiometricsUploadComponent } from './biometrics-upload/biometrics-upload.component';
import { BiometricsValidatorComponent } from './biometrics-validator/biometrics-validator.component';

const routes: Routes = [
  {
    path: routesData.BIOMETRY.CONFIG.path,
    component: BiometricsInitComponent
  },
  {
    path: routesData.BIOMETRY.INFO.path,
    component: BiometricsInstructionsComponent
  },
  {
    path: routesData.BIOMETRY.LAUNCHER.path,
    component: BiometricsLauncherComponent
  },
  {
    path: routesData.BIOMETRY.RESULT.path,
    component: BiometricsResultComponent
  },
  {
    path: routesData.BIOMETRY.UPLOAD.path,
    component: BiometricsUploadComponent
  },
  {
    path: routesData.BIOMETRY.VALIDATION.path,
    component: BiometricsValidatorComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BiometricsRoutingModule {}
